module.exports = __webpack_public_path__ + "media/images/download-59f54a819e5b4d7de7eeab1bd4fc1103.svg";